import { html, LitElement } from 'lit';

class ChecklistIcon extends LitElement {
  render() {
    return html`<svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_126_12)">
        <path
          d="M18.92 32.12L34.43 16.61L31.35 13.53L18.92 25.96L12.65 19.69L9.57 22.77L18.92 32.12ZM22 44C18.9567 44 16.0967 43.4221 13.42 42.2664C10.7433 41.1121 8.415 39.545 6.435 37.565C4.455 35.585 2.88787 33.2567 1.7336 30.58C0.577867 27.9033 0 25.0433 0 22C0 18.9567 0.577867 16.0967 1.7336 13.42C2.88787 10.7433 4.455 8.415 6.435 6.435C8.415 4.455 10.7433 2.88713 13.42 1.7314C16.0967 0.577133 18.9567 0 22 0C25.0433 0 27.9033 0.577133 30.58 1.7314C33.2567 2.88713 35.585 4.455 37.565 6.435C39.545 8.415 41.1121 10.7433 42.2664 13.42C43.4221 16.0967 44 18.9567 44 22C44 25.0433 43.4221 27.9033 42.2664 30.58C41.1121 33.2567 39.545 35.585 37.565 37.565C35.585 39.545 33.2567 41.1121 30.58 42.2664C27.9033 43.4221 25.0433 44 22 44ZM22 39.6C26.9133 39.6 31.075 37.895 34.485 34.485C37.895 31.075 39.6 26.9133 39.6 22C39.6 17.0867 37.895 12.925 34.485 9.515C31.075 6.105 26.9133 4.4 22 4.4C17.0867 4.4 12.925 6.105 9.515 9.515C6.105 12.925 4.4 17.0867 4.4 22C4.4 26.9133 6.105 31.075 9.515 34.485C12.925 37.895 17.0867 39.6 22 39.6Z"
          fill="#E88F2A"
        />
      </g>
      <defs>
        <clipPath id="clip0_126_12">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>`;
  }
}

customElements.define('checklist-icon', ChecklistIcon);
